import { actionGenerator } from '../../utils/redux/actionGenerator';

export const CHANGE_GEO_SEARCH = 'filters/change_geo_search' as const;

export const changeGeoSearch = actionGenerator<typeof CHANGE_GEO_SEARCH, string>(CHANGE_GEO_SEARCH);

export type TChangeGeoSearch = ReturnType<typeof changeGeoSearch>;
